module.exports = __webpack_public_path__ + "static/media/arrow-right.e14555be.svg";